export const DISCOVERY_TAG_TYPE = 'Discovery' as const;
export const DISCOVERY_LIST_ID = 'LIST' as const;
export const DISCOVERY_MAP_ID = 'MAP' as const;
